import React from 'react';
import { Switch, Route, Redirect, Link as NavLink } from 'react-router-dom';
import moment from 'moment';
import { useMutation } from '@apollo/react-hooks';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { GET_SCHOOLS, ADD_SCHOOL } from 'graphql/student_college';
import Helmet from 'react-helmet';
import useSnack from 'hooks/useSnack';
import { useSelector } from 'react-redux';
import Tracker from './Tracker';
import Research from './Research';
import SchoolListView from './SchoolList';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PersonIcon from '@material-ui/icons/Person';
import FlagIcon from '@material-ui/icons/Flag';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import PRODUCTS from 'constant/product-types';

const PRODUCTS_LOOKUP = PRODUCTS.reduce((memo, i) => {
  memo[i.value] = i.label;
  return memo;
}, {});

export const LISTS = [
  {
    type: 'student',
    name: 'Student List',
    index: 0,
    color: '#696D75',
    Icon: PersonIcon,
  },
  {
    type: 'reach',
    name: 'Reach',
    index: 1,
    color: '#8A53FF',
    Icon: FlagIcon,
  },
  {
    type: 'target',
    name: 'Target',
    index: 2,
    color: '#F79900',
    Icon: GpsFixedIcon,
  },
  {
    type: 'safety',
    name: 'Safety',
    index: 3,
    color: '#25C186',
    Icon: VerifiedUserIcon,
  },
];

const NavTab = withStyles((theme) => ({
  root: {
    minWidth: 72,
  },
}))(Tab);

const SchoolContainer = ({
  student,
  history,
  match,
  location: { pathname },
}) => {
  const snack = useSnack();
  const [addSchool] = useMutation(ADD_SCHOOL);
  const user = useSelector((state) => state.user.user);
  const isStudent = user.type === 'student';
  const routePrefix = isStudent ? '' : `/students/${student.id}`;
  const queryParams = { student_sub: student.sub };

  const onAddSchool = (category, college, dueDate, location=null) => {
    return addSchool({
      variables: {
        input: {
          category,
          college_name: college.label,
          college_id: String(college.value),
          student_sub: student.sub,
          app_deadline: dueDate && moment(dueDate).format('YYYY-MM-DD'),
          college_location: location
        },
      },
      update: (store, resp) => {
        const data = store.readQuery({
          query: GET_SCHOOLS,
          variables: queryParams,
        });
        data.student_college.push(
          resp.data.insert_student_college.returning[0],
        );
        store.writeQuery({
          query: GET_SCHOOLS,
          variables: queryParams,
          data,
        });
      },
    })
      .then(() => {
        window.analytics.track('School added to School list', {
          category,
          college_name: college.label,
          college_id: String(college.value),
          student_sub: student.sub,
          app_deadline: dueDate && moment(dueDate).format('YYYY-MM-DD'),
          product: PRODUCTS_LOOKUP[student.product_type],
          user
        });
        snack.success('School successfully added.');
      })
      .catch((e) => snack.error(e.message));
  };
  return (
    <div>
      <Helmet title="Schools" />
      <Box>
        <Tabs value={pathname} indicatorColor="primary" textColor="primary">
          <NavTab
            component={NavLink}
            to={`${routePrefix}/schools/research`}
            value={`${routePrefix}/schools/research`}
            label="Research"
          />
          <NavTab
            component={NavLink}
            to={`${routePrefix}/schools/list`}
            value={`${routePrefix}/schools/list`}
            label="School List"
          />
          <NavTab
            component={NavLink}
            to={`${routePrefix}/schools/tracker`}
            value={`${routePrefix}/schools/tracker`}
            label="Application Tracker"
          />
        </Tabs>
      </Box>
      <Switch>
        <Route
          path={`${routePrefix}/schools/tracker`}
          component={(props) => <Tracker student={student} {...props} />}
        />
        <Route
          exact
          path={`${routePrefix}/schools/research`}
          render={() => (
            <Research
              student={student}
              addSchool={onAddSchool}
              history={history}
            />
          )}
        />
        <Route
          path={`${routePrefix}/schools/list`}
          component={(props) => (
            <SchoolListView
              {...props}
              student={student}
              onAddSchool={onAddSchool}
            />
          )}
        />
        <Redirect
          from={`${routePrefix}/schools`}
          to={`${routePrefix}/schools/list`}
        />
      </Switch>
    </div>
  );
};

export default SchoolContainer;
